var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/extensions/Link/x-tiptap-prompt-link.ts
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-button.js";
import "@adornis/chemistry/elements/components/x-flex.js";
import { DesignSystem } from "@adornis/chemistry/elements/theming/design.js";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import { XNativeDialog } from "@adornis/dialog/x-native-dialog.js";
import "@adornis/fonts/fonts.js";
import "@adornis/forms/x-checkbox.js";
import "@adornis/forms/x-input.js";
import { html } from "lit";
import { customElement, property } from "lit/decorators.js";
var XTiptapPromptLink = class extends XNativeDialog {
  constructor() {
    super(...arguments);
    this.href = "";
    this.openInNewTab = true;
  }
  static get element_name() {
    return "x-tiptap-prompt-link";
  }
  content() {
    return xComponents(html`
      <x-flex
        ${css({
      padding: `${DesignSystem.currentTheme.getValue().spacing.sm} ${DesignSystem.currentTheme.getValue().spacing.lg}`,
      gap: "24px"
    })}
      >
        <x-h4> Erstelle einen Link </x-h4>

        <x-input
          .value=${this.href}
          placeholder=${"Link"}
          @value-picked=${(e) => {
      this.href = e.detail.value;
    }}
        ></x-input>
        <x-checkbox
          .value=${this.openInNewTab}
          .label=${"In neuem Fenster \xF6ffnen"}
          @value-picked=${(e) => {
      this.openInNewTab = e.detail.value;
    }}
        ></x-checkbox>

        <x-flex horizontal center space="md">
          <x-button tone="neutral" mode="outline" @click=${() => this.cancel()}> Abbrechen </x-button>
          <x-button
            mode="action"
            @click=${() => this.close({ href: this.href, target: this.openInNewTab ? "_blank" : "_self" })}
          >
            Speichern
          </x-button>
        </x-flex>
      </x-flex>
    `);
  }
  async cancel(returnVal) {
    return this.close(null);
  }
};
__decorateClass([
  property({ attribute: false })
], XTiptapPromptLink.prototype, "href", 2);
__decorateClass([
  property({ attribute: false })
], XTiptapPromptLink.prototype, "openInNewTab", 2);
XTiptapPromptLink = __decorateClass([
  customElement("x-tiptap-prompt-link")
], XTiptapPromptLink);
export {
  XTiptapPromptLink
};
